<div class="modal fade" id="upcomingEventModal" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content d-flex">
        <div [style.background-color]="eventDetail.color" [style.color]="eventDetail.color" class="text-xs rounded-top w-5">{{eventDetail.color}}</div>
        <div>
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body pt-0">
                <div class="text-uppercase">
                  <h3 class="modal-title mb-3">{{eventDetail.eventName}}</h3>
                  <div class="mt-2 w-100 text-sm" *ngIf="eventDetail.assessmentlink ">
                    <a class ="text-lowercase text-center " [href]="eventDetail.assessmentlink">click to see assessment details</a>
                  </div>
                  <div class="rounded-md shadow-sm-darker d-flex justify-content-between align-items-center p-2" *ngIf="eventDetail.venue">
                    <h4 class="text-primary-darker text-left mb-0 d-inline" id="venue">{{ eventDetail.isLink ? 'Link:' : 'Venue:' }}</h4>
                    <a *ngIf="eventDetail.isLink" [href]="eventDetail.venue" target="_blank"><p class="text-sm font-italic d-inline text-underline text-lowercase"> {{eventDetail.venue.length < 85 ? eventDetail.venue : 'Click here'}}</p></a>
                    <p class="d-inline " *ngIf="!eventDetail.isLink"> {{eventDetail.venue}} </p>
                  </div>
                  <div class="rounded-md shadow-sm-darker d-flex justify-content-between align-items-center p-2" *ngIf="eventDetail.lessonName">
                    <h4 class="text-primary-darker text-left mb-0 d-inline" id="lessonName">Lesson Title:</h4>
                    <p class="d-inline "> {{eventDetail.lessonName}} </p>
                  </div>
                  <div class="rounded-md shadow-sm-darker d-flex justify-content-between align-items-center mt-2 p-2">
                    <h4 class="text-primary-darker d-inline text-left mb-0">Start Time: </h4>
                    <p class="d-inline m-0">{{util.formatDate(eventDetail.originalstart)}}</p>
                  </div>
                  <div class="rounded-md shadow-sm-darker d-flex justify-content-between align-items-center p-2 mt-2">
                    <h4 class="text-primary-darker d-inline text-left mb-0">End Time: </h4>
                    <p class="d-inline m-0">{{util.formatDate(eventDetail.originalend)}}</p>
                  </div>
                </div>
                <div class="mt-3">
                  <div #eventdescriptionbody class="bodycontainer card shadow-sm-darker p-2" style="overflow: auto; max-height: 30vh;" [innerHTML]="combinedHTML"></div>
                </div>
                <div class="d-flex justify-content-center flex-wrap gap-1.5">
                  <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
